import { render, staticRenderFns } from "./dialogMain.vue?vue&type=template&id=50694dce&scoped=true&"
import script from "./dialogMain.vue?vue&type=script&lang=js&"
export * from "./dialogMain.vue?vue&type=script&lang=js&"
import style0 from "./dialogMain.vue?vue&type=style&index=0&id=50694dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50694dce",
  null
  
)

export default component.exports